import { memo } from 'react';
import { Handle, Position } from '@xyflow/react';
import { CardShell } from '../CardShell';
import { getNodeDisplayLabel, useFlowDisplayLanguage } from '../../displayLanguage';
import { MAZE_GOAL_SOURCE_HANDLES } from '../mazeGoalHandles';

export const MazeGoalNodeView = memo(function MazeGoalNodeView() {
  const displayLanguage = useFlowDisplayLanguage();

  return (
    <CardShell
      kind="mazeGoal"
      accent="amber"
      title={getNodeDisplayLabel('mazeGoal', displayLanguage)}
      summary={displayLanguage === 'en' ? 'Current position' : '現在位置'}
    >
      <div className="flow-node__port-label flow-node__port-label--in text-amber-700" style={{ top: '50%', transform: 'translateY(-50%)' }}>
        {displayLanguage === 'en' ? 'input' : '入力'}
      </div>
      <div className="flow-node__port-label flow-node__port-label--out text-amber-700" style={{ top: '30%', transform: 'translateY(-50%)' }}>
        true
      </div>
      <div className="flow-node__port-label flow-node__port-label--out text-amber-700" style={{ top: '70%', transform: 'translateY(-50%)' }}>
        false
      </div>
      <Handle type="target" position={Position.Left} style={{ top: '50%' }} className="!bg-amber-500" />
      <Handle id={MAZE_GOAL_SOURCE_HANDLES.true} type="source" position={Position.Right} style={{ top: '30%' }} className="!bg-amber-500" />
      <Handle id={MAZE_GOAL_SOURCE_HANDLES.false} type="source" position={Position.Right} style={{ top: '70%' }} className="!bg-amber-500" />
    </CardShell>
  );
});
